package com.tregz.tremenz.io.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * The shape of the bundled catalogue payloads, kept apart from [ModelData] so the wire format can
 * change without touching the domain classes the UI reads. Every field is nullable or defaulted:
 * the payloads are hand-edited and the old per-platform parsers tolerated anything missing.
 * Numbers are [Double] because the JS target hands back doubles for whole values like `2024`.
 */
@Serializable
internal data class ModelWireSong(
    val artist: String = "",
    val name: String = "",
    val featuring: String? = null,
    val mixedBy: String? = null,
    val genre: String? = null,
    val releasedAt: Double? = null
)

/** One entry of `music_videos.json`; the video id is derived from [youtubeUrl]. */
@Serializable
internal data class ModelWireClip(
    @SerialName("youtube_url") val youtubeUrl: String = "",
    val artist: String = "",
    val title: String = "",
    val genre: String? = null,
    @SerialName("release_date") val releaseDate: String = "",
    val artwork: String? = null
)

/** One entry of `mixes.json`. */
@Serializable
internal data class ModelWireMix(
    val id: String = "",
    val name: String = "",
    val path: String? = null,
    val type: String = "",
    val year: Double = 0.0,
    val sono: String? = null,
    val host: String? = null,
    val posterUrl: String? = null,
    val list: List<ModelWireTrack> = emptyList()
)

/** One track of a [ModelWireMix]. */
@Serializable
internal data class ModelWireTrack(
    val id: String = "",
    val artist: String = "Undefined artist",
    val cut: String? = null,
    val edition: String? = null,
    val featuring: String? = null,
    val mix: String? = null,
    val title: String = "Undefined title"
)
